import {toast} from "react-toastify";
import Swal from "sweetalert2";

export const displayLog = (text, type) => {
    let options = {
        // duration: 1045464554000,
        // gutter: 1,
        position: "top-right",
        iconTheme: {
            // primary: "#383a87",
            // secondary: "#fff",
        }
        // style: {
        //   marginTop: "85px",
        // },
    };

    if (type === "success") {
        toast.success(text, options);
    } else if (type === "error") {
        toast.error(text, options);
    } else {
        toast(text, options);
    }
};

export const displayConfirmation = (html, flag) => {
    let options = {
        // title: title,
        html: html,
        // text: text,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: "#383A87",
        confirmButtonText: "Move to Archive",
        cancelButtonText: "Review Later",
        reverseButtons: true
    };

    if (flag) {
        options = {
            ...options,
            confirmButtonColor: "#383A87",
            confirmButtonText: "Yes, I'm sure",
            cancelButtonText: "No, Cancel",
            input: "checkbox",
            inputPlaceholder: "Don't ask me this again."
        };
    }

    return Swal.fire(options);
};
export const apiCall = async () => {
    return 0;
};
export const getFileName = (fileName) => {
    const lowerFileName = fileName.toLowerCase();
    const fileExtension = fileName.split(".").pop();
    const mappedNames = {
        "trexo-drm-opendocketpa": "TREXO-DRM-OPENDOCKETPA",
        "trexo-drm-opendocket_pa": "TREXO-DRM-OPENDOCKETPA",
        "trexo-drmindiamatterspa": "TREXO-DRMINDIAMATTERSPA",
        "trexo-drmindiamatters_pa": "TREXO-DRMINDIAMATTERSPA",
        "trexo-workingstmtpa": "TREXO-WORKINGSTMTPA",
        "trexo-workingstmt_pa": "TREXO-WORKINGSTMTPA",
        "trexo-drm-bibliographicpa": "TREXO-DRM-BIBLIOGRAPHICPA",
        "trexo-drm-bibliographic_pa": "TREXO-DRM-BIBLIOGRAPHICPA",
        "trexo-drm-bibliographictm": "TREXO-DRM-BIBLIOGRAPHICTM",
        "trexo-drm-bibliographic_tm": "TREXO-DRM-BIBLIOGRAPHICTM",
        "bibliographicpa": "BibliographicPA",
        "bibliographic_pa": "BibliographicPA",
        "closeddocketpa": "ClosedDocketPA",
        "closeddocket_pa": "ClosedDocketPA",
        "opendocketpa": "OpenDocketPA",
        "opendocket_pa": "OpenDocketPA",
        "pairpa": "PairPA",
        "pair_pa": "PairPA",
        "outgoingcorrespondence": "PairPA",
        "indiamatterspa": "IndiaMattersPA",
        "indiamatters_pa": "IndiaMattersPA",
        "workingstmtpa": "WorkingStmtPA",
        "workingstmt_pa": "WorkingStmtPA",
        "closeddockettm": "ClosedDocketTM",
        "closeddocket_tm": "ClosedDocketTM",
        "bibliographictm": "BibliographicTM",
        "bibliographic_tm": "BibliographicTM",


        "cpi_bibliographytm": "CPI_BibliographyTM",
        "cpi_bibliography_tm": "CPI_BibliographyTM",
        "cpi_create_actiontm": "CPI_Create_ActionTM",
        "cpi_create_action_tm": "CPI_Create_ActionTM",
        "cpi_last_actiontm": "CPI_Last_ActionTM",
        "cpi_last_action_tm": "CPI_Last_ActionTM",
        "user name": "User Name",
        "user_name": "User Name",
        "output": "90dayOutput",
        "dayoutput": "90dayOutput",

        

    };
    for (const [key, value] of Object.entries(mappedNames)) {
        
        if (lowerFileName.includes(key)) {
            return `${value}.${fileExtension}`;
        }
    }
    return "notFound";
};


export const confirmPartialFilesDialogue = (html) => {
    let options = {
        // title: title,
        html: html,
        // text: text,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: "#383A87",
        confirmButtonText: "Run",
        cancelButtonText: "Cancel",
        reverseButtons: true
    };

    return Swal.fire(options);
};

export const stopUploadDialogue = (html) => {
    let options = {
        // title: title,
        html: html,
        // text: text,
        // showCancelButton: true,
        // confirmButtonColor: "#383a87",
        confirmButtonColor: "#383A87",
        confirmButtonText: "Ok",
        reverseButtons: true
    };

    return Swal.fire(options);
};